'use strict';

class Viploungedialog {

	static bind_ios_scroll() {
		document.querySelectorAll('.vip_lounge_dialog_plp .plp__text').forEach((el) => {
			if (el._vip_lounge_scroll_ok) return;
			el._vip_lounge_scroll_ok = true;
			el.addEventListener('touchmove', (e) => {
				e.stopPropagation();
			}, { passive: true });
		});
	}

	static init() {
		jQuery(document)
			.off('click.js-viplounge', '.js-viplounge_tab')
			.on('click.js-viplounge', '.js-viplounge_tab', (e) => {
				const $tab = jQuery(e.target).closest('.js-viplounge_tab');
				const panel = $tab.data('panel');
				const $dialog = $tab.closest('.js-viplounge');

				$dialog.find('.js-viplounge_tab_active').removeClass('viploungedialog__tab--active js-viplounge_tab_active');
				$tab.addClass('viploungedialog__tab--active js-viplounge_tab_active');
				$dialog.find('.js-viplounge_panel_active').removeClass('viploungedialog__panel--active js-viplounge_panel_active');
				$dialog.find('.js-viplounge_panel[data-panel="' + panel + '"]').addClass('viploungedialog__panel--active js-viplounge_panel_active');
			})
			.off('click.js-viplounge', '.js-viplounge_cta_spotlight')
			.on('click.js-viplounge', '.js-viplounge_cta_spotlight', () => {
				jQuery('.js-vip_lounge_plp').trigger('plp_hide');
			})
			.off('plp_show.js-viplounge', '.js-vip_lounge_plp')
			.on('plp_show.js-viplounge', '.js-vip_lounge_plp', () => Viploungedialog.bind_ios_scroll());

		Viploungedialog.bind_ios_scroll();
	}
}

class Bstvipspotlightlounge {
	constructor($root) {
		this.$root = $root;
		this.load_promise = null;
		this.content_promise = null;
	}

	init() {
		this.$root
			.off('click.js-bstvipspotlightlounge')
			.on('click.js-bstvipspotlightlounge', '.js-bstvipspotlightlounge_open_plp', () => this.open_plp());

		this.load_content();
	}

	load_content() {
		const $placeholder = jQuery('.bstvipspotlightlounge--skeleton, .bstvipspotlightlounge--pending');
		if (!$placeholder.length) {
			return;
		}

		if (this.content_promise) {
			return;
		}

		const ajax_data = {
			action: 'load_lounge_content',
			areaID: yalwa.v.areaID,
			leaf_categoryID: yalwa.v.current_categoryID
		};

		const page_params = new URLSearchParams(window.location.search);
		const forward_params = ['vip_dummy_ads', 'spotlight_dummy_ads', 'hide_spotlight', 'lounge_version', 'skip_vip_cache'];
		forward_params.forEach((key) => {
			if (page_params.has(key)) {
				ajax_data[key] = page_params.get(key);
			}
		});

		this.content_promise = jQuery.ajax({
			url: '/api/ajax/spotlight',
			type: 'get',
			dataType: 'json',
			data: ajax_data
		}).then((response) => {
			if (!response.success || !response.html) {
				$placeholder.remove();
				return;
			}

			const $assets_loader = yalwa.mobile.assets_loader();
			$assets_loader.load_assets_only(response);

			const css_promises = (response.assets?.css || []).map(url => yalwa.basics.load_css(url));
			Promise.all(css_promises).then(() => {
				$placeholder.replaceWith(jQuery(response.html).removeClass('js-detach_body'));
				new Bstvipspotlightlounge(jQuery('.js-bstvipspotlightlounge_bst')).init();
			});
		}).fail(() => {
			$placeholder.remove();
		}).always(() => {
			this.content_promise = null;
		});
	}

	open_plp() {
		const $plp = jQuery('.js-vip_lounge_plp');
		if ($plp.length) {
			$plp.trigger('plp_show');
			return;
		}

		if (this.load_promise) {
			return;
		}

		this.load_promise = jQuery.ajax({
			url: '/api/ajax/spotlight',
			type: 'get',
			dataType: 'json',
			data: {
				action: 'load_vip_lounge_plp',
				areaID: yalwa.v.areaID,
				leaf_categoryID: yalwa.v.current_categoryID
			}
		}).then((response) => {
			if (!response.success || !response.html) {
				return;
			}

			return yalwa.mobile.assets_loader().load_assets_and_append_html({
				...response,
				assets: {...response.assets, js: []},
				html: jQuery(response.html).removeClass('js-detach_body'),
				$append_to: jQuery('.js-plp_container')
			}).then(() => {
				jQuery('.js-vip_lounge_plp').trigger('plp_show');
			});
		}).always(() => {
			this.load_promise = null;
		});
	}
}

Viploungedialog.init();

(function () {
	const $placeholder = jQuery('.bstvipspotlightlounge--skeleton, .bstvipspotlightlounge--pending');
	if ($placeholder.length) {
		new Bstvipspotlightlounge($placeholder).init();
		return;
	}

	jQuery('.js-bstvipspotlightlounge_bst').each(function() {
		new Bstvipspotlightlounge(jQuery(this)).init();
	});
})();
